// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__0E+Ib","mensagem":"Overlay_mensagem__2q4vT"};